import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import { API_GW_URL } from './config/api'

import './registerServiceWorker'
import Vue3TouchEvents from "vue3-touch-events";

export { API_GW_URL }
createApp(App).use(store).use(router).use(Vue3TouchEvents).mount('#app')
